import { createFileRoute, Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { COURSES } from "@/lib/data/courses";
import { CourseCard } from "@/components/trainer/CourseCard";
import { AboutHamdIntro } from "@/components/trainer/AboutHamdIntro";
import { useAuthStore } from "@/lib/stores/authStore";
import { useTrainerAuthRedirect } from "@/lib/hooks/useTrainerAuthRedirect";

export const Route = createFileRoute("/trainer/courses/")({
  component: CoursesHome,
  head: () => ({ meta: [{ title: "Courses - HAMD" }] }),
});

function CoursesHome() {
  const user = useAuthStore((s) => s.user);
  const isTrainer = user?.accountType === "TRAINER";
  const { setAuthOrigin } = useTrainerAuthRedirect();

  return (
    <main className="space-y-6 px-4 pb-6">
      <header className="space-y-1">
        <h1 className="text-h1 font-medium text-black">
          <FormattedMessage id="trainer.courses.title" />
        </h1>
        <p className="text-small text-dark-gray">
          <FormattedMessage id="trainer.courses.subtitle" />
        </p>
      </header>

      <AboutHamdIntro />

      {!isTrainer && (
        <div className="rounded-2xl bg-card p-4">
          <p className="text-small text-dark-gray">
            <FormattedMessage id="trainer.courses.guestNotice" />
          </p>
          <Link
            to="/trainer/auth"
            onClick={() => setAuthOrigin(null)}
            className="mt-2 inline-block text-small font-medium text-primary"
          >
            <FormattedMessage id="trainer.courses.guestRegister" />
          </Link>
        </div>
      )}

      <div className="space-y-4">
        {COURSES.map((course) => (
          <CourseCard key={course.slug} course={course} />
        ))}
      </div>
    </main>
  );
}
